import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentComponent } from './component/environment/environment.component';

@NgModule({
  declarations: [EnvironmentComponent],
  imports: [CommonModule],
  exports: [EnvironmentComponent],
})
export class EnvironmentModule {}
